import React, {useState} from 'react';
import './Ajuda.css';

import Modal from '../../modal/Modal';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faQuestion, faTimesCircle} from '@fortawesome/free-solid-svg-icons';


const Ajuda = () => {

	const [isOpen, setIsOpen] = useState(false);

	const ajudaButton = <div className="contentAjudaButton row nowrap  startContent centerItens" onClick= {()=>{setIsOpen(!isOpen)}}>
							<div className="icon">
								<FontAwesomeIcon icon={faQuestion}/>
							</div>
							<div className="name">
								Ajuda
							</div>
						</div>;

	return(
		<Modal button={ajudaButton} visible={isOpen}>
			<div className="modalAjuda">
				<div className="head row nowrap centerContent">
					<img className="teacher"src="/app/infocovidmais/images/layout/teacher.png" alt="Professora"/>
					<div className="title colorEIC3">Ajuda</div>
					<div className="box column nowrap spaceAroundContent">
						<div className = "close colorEIC3 shadow column spaceAroundContent centerItens startItens">
							<FontAwesomeIcon className="close" icon = {faTimesCircle} onClick = {()=>{setIsOpen(!isOpen)}} />
						</div>
					</div>
				</div>
				
				<div className="content column nowrap justifyText">
					<div className="backgroundEIC3">Para jogar, escolha entre um dos tópicos.</div>
					<div className="backgroundEIC3">Para expandir a imagem do informativo, clique sobre a imagem.</div>
					<div className="backgroundEIC3">Para iniciar o jogo, clique no centro da imagem.</div>
					<div className="backgroundEIC3">Para movimentar a peça, clique, segure e arraste.</div>
					<div className="backgroundEIC3">Quanto mais rápido for, melhor será sua posição.</div>
				</div>
			</div>
		</Modal>
	);
};


export default Ajuda;

